import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Typography from "../../components/Typography";
import { theme } from "../../theme";
import { useAuth } from "../../context/AuthContext";
import Button from "../../components/Button/Button";
import { openUserSettingsModal } from "../../utils/settingsNavigation";

const MyEventsSettings = () => {
	const { t } = useTranslation("hostedEvents");
	const { user } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const targetUserId = user?.id || user?._id;

	return (
		<>
			<MyEventsSettingsSection>
				<Container>
					<HeaderBlock>
						<Typography
							as="h1"
							$variant="title-3-semibold"
							$variantTablet="title-4-semibold"
							$variantMobile="body-1-semibold"
						>
							{t("settings.ticketSales.title")}
						</Typography>
						<Typography
							as="p"
							$variant="body-1-medium"
							$variantTablet="body-2-medium"
							$variantMobile="body-2-medium"
							color={theme.colors.defaultStrong}
						>
							{t("settings.ticketSales.description")}
						</Typography>
					</HeaderBlock>
					<CardContainer>
						<RedirectCard>
							<Typography
								as="p"
								$variant="body-1-medium"
								color={theme.colors.defaultStrong}
							>
								{t("settings.ticketSales.redirectTitle")}
							</Typography>
							<Typography
								as="p"
								$variant="body-2-medium"
								color={theme.colors.defaultWeak}
							>
								{t("settings.ticketSales.redirectDescription")}
							</Typography>
							<Button
								size="l"
								onClick={() =>
									targetUserId &&
									openUserSettingsModal({
										navigate,
										location,
										userId: targetUserId,
									})
								}
								disabled={!targetUserId}
							>
								{t("settings.ticketSales.openSettings")}
							</Button>
						</RedirectCard>
					</CardContainer>
				</Container>
				{/* <Container>
          <HeaderBlock>
            <Typography as="h1" $variant="title-3-semibold" $variantTablet="title-4-semibold" $variantMobile="body-1-semibold">{t('settings.defaultOptions.title')}</Typography>
            <Typography as="p" $variant="body-1-medium" $variantTablet="body-2-medium" $variantMobile="body-2-medium" color={theme.colors.defaultStrong}>{t('settings.defaultOptions.description')}</Typography>
          </HeaderBlock>
        </Container> */}
			</MyEventsSettingsSection>
		</>
	);
};

export default MyEventsSettings;

const MyEventsSettingsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultMain};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.sizing.md} ${({ theme }) => theme.sizing.md};
  padding-bottom: 0px;
  width: 100%;
  max-width: 1400px;
  gap: ${({ theme }) => theme.sizing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.sm};
    padding-bottom: 0px;
  }
`;

const HeaderBlock = styled.div`
display: flex;
flex-direction: column;
gap: ${({ theme }) => theme.sizing.xxs};
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  // border-radius: ${({ theme }) => theme.sizing.sm};
  // border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  overflow: hidden;
`;

const RedirectCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizing.sm};
  padding: ${({ theme }) => theme.sizing.md};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.md};
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
`;
